if (!customElements.get('wv-shelf-snap-video')) {
 customElements.define('wv-shelf-snap-video', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const options = {signal: this.abort.signal};
   this.video = this.querySelector('video');
   this.button = this.querySelector('button');
   this.status = this.querySelector('[role="status"]');
   this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
   this.video.muted = true;
   this.visible = false;
   this.userPaused = false;
   this.button.addEventListener('click', () => {
    this.userPaused = false;
    if (this.video.error) this.video.load();
    this.playVideo();
   }, options);
   this.video.addEventListener('playing', () => {
    this.button.hidden = true;
    this.status.hidden = true;
    this.userPaused = false;
   }, options);
   this.video.addEventListener('pause', () => {
    this.button.hidden = false;
    if (this.visible && !document.hidden) this.userPaused = true;
   }, options);
   this.video.addEventListener('error', () => {
    this.button.hidden = false;
    this.status.hidden = false;
   }, options);
   this.video.addEventListener('loadeddata', () => this.autoplay(), options);
   this.observer = new IntersectionObserver(entries => {
    this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
    if (this.visible) this.autoplay();
    else this.video.pause();
   }, {threshold: [0, .15]});
   this.observer.observe(this);
   document.addEventListener('visibilitychange', () => {
    if (document.hidden) this.video.pause();
    else this.autoplay();
   }, options);
   this.reduced.addEventListener('change', () => {
    if (this.reduced.matches) this.video.pause();
    else this.autoplay();
   }, options);
  }
  autoplay() {
   if (this.visible && !document.hidden && !this.reduced.matches && !this.userPaused) this.playVideo();
  }
  playVideo() {
   this.status.hidden = true;
   this.video.play().catch(() => { this.button.hidden = false; });
  }
  disconnectedCallback() {
   this.observer?.disconnect();
   this.abort?.abort();
   this.video?.pause();
  }
 });
}
